<template>
    <div>
        <shopping-cart @editCartItem="edit_cart_item" />
        <product-modal 
        	v-if="isShowProduct"
			:data_item="modal_item"
			:cart-item-index="modal_cart_item_index"
            @close="closeModal" />
    </div>
</template>
<script>
import ProductModal from "@/components/menu/ProductModal.vue";
import ShoppingCart from "@/components/menu/ShoppingCart.vue";
import {mapState} from 'vuex'
    
export default {
    components: {
        ProductModal,
        ShoppingCart
    },
    data(){
        return {
 			modal_item: null,
            modal_cart_item_index: null,
            isShowProduct: false,
        }
    },
    methods:{
        hash_change(hash){
            let oldURL = new URL(hash.oldURL)
            let newURL = new URL(hash.newURL)
            if(newURL.hash === "#/shopping-cart-page" && oldURL.hash === "#/ProductModal"){
                this.closeModal()
            }
        },
        edit_cart_item(index)
			{
				var cartItem = this.$store.getters.cartItems.find( (item,i) => i == index )
				this.modal_item = cartItem.item;
				this.modal_cart_item_index = index;
			    this.isShowProduct = true
			},	
        closeModal() 
        {
            this.isShowProduct = false
        }
    },
    watch:{
        isShowProduct(){
            if(!this.isShowProduct && window.location.hash === "#/ProductModal"){					
                history.back()
            }
        }                   
    },
    computed: {
        ...mapState({
            store: 'store'
        })
    },
    created: function () {
		window.addEventListener('hashchange', this.hash_change)
	},
    destroyed: function () {
        window.removeEventListener('hashchange', this.hash_change)
    }
}
</script>
<style scoped>

</style>